<div class="body widget-list-body">
    <div class="widget-header">
        <span class="headline">Auftragseingang</span>
    </div>
    <div class="widget-list-content">

        <ng-container *ngIf="mailsLoaded && noMailsInBox; else entryList">
            <div class="no-entries-hint">
                <div class="spacer"></div>
                <mat-icon class="icon success">done</mat-icon>
                <div class="text">keine unbearbeiteten Aufträge im Posteingang</div>
                <div class="spacer double"></div>
            </div>
        </ng-container>
        
        <ng-template #entryList>
            <div class="entry" *ngFor="let mail of mails" (click)="mailClicked(mail)">
                <app-mail-list-entry [currentMail]="mail"></app-mail-list-entry>
            </div>
        </ng-template>
        
    </div>
</div>